import { getPaymentRequestedData } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';

export const cartDataFields = data => {
  return (
    data?.map((key, index) => {
      return (<>
      <input type="hidden" name={`name[${index}]`} value={`${key.item.name}`}></input>
      <input type="hidden" name={`quantity[${index}]`} value={`${key.quantity}`}></input>
      <input type="hidden" name={`price[${index}]`} value={`${key.amount/100}`}></input>           
    </>
    )}
  )
  )
}

export const dispatchPaymentRequest = props => {
  const { checkoutDetails } = props;
  const { dispatch } = checkoutDetails || {};
  checkoutDetails?.isClickAddPayment &&
    dispatch(
      getPaymentRequestedData( 
          {
            tenantId: checkoutDetails?.tenantId,
            data: {
              orderId: checkoutDetails?.orderId,
              tenderType: checkoutDetails?.tender?.name,
            },
          }
      ),
    );
};
